export enum CARD_ITEMS {
    ACCESS_GROUP = "access group",
    CREATED_AT = "created at",
    ID = "id",
    INVITED_BY = "invited by",
    ROLE = "role",
    UPDATED_AT = "updated at"
}
